import { Plugin } from '@nuxt/types'

export default (({ store }) => {
  store?.dispatch('user/fetch')
}) as Plugin
